import React from 'react';

import ListItem from '@material-ui/core/ListItem';

import styles from './Clue.module.scss';

export default class Clue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const clue = this.props.clue;

    return (
      <ListItem className={styles.root} onClick={() => this.props.onClickClueFunc(clue)}>
        <div className={styles.clue}>
          <div className={styles.largeColumn}>{clue.name}</div>
          <div className={styles.largeColumn}>
            <span className={styles.action}>{clue.type}</span>
          </div>
        </div>
      </ListItem>
    );
  }
}
